import React from 'react'
import Header from '../component/Header'
import CommonBanner from '../component/CommonBanner'
import Footer from '../component/Footer'
import ExploreResultLocations from '../component/ExploreResultLocations'
import { Card, Col, Container, Row } from 'react-bootstrap'
import PhoneNumber from '../assets/images/phone-number.svg'
import EmailUs from '../assets/images/email-us.svg'
import ConnectUs from '../assets/images/connect-us.svg'
import Facebook from '../assets/images/facebook-2.svg'
import X from '../assets/images/x-2.svg'
import Instagram from '../assets/images/instagram-2.svg'
import YouTube from '../assets/images/youtube-2.svg'
import LinkedIn from '../assets/images/linkedin.svg'

function ContactUs() {
  return (
    <>
      <div className='main contact-us-page'>
        <Header/>
        <CommonBanner title="Contact Us" />
        <div className="contact-us common-padding">
          <Container>
              <div className="common-header text-center">
                <h2>Get In Touch</h2>
                <p>We’re here to help!<br/> Our National Customer Service Team is available <br/> 8am - 5pm PST, seven days a week.</p>
              </div>
              <Row className="g-4 justify-content-center">
                  <Col md={4}>
                  <Card>
                      <img src={PhoneNumber} alt=""></img>
                      <p>Phone Number</p>
                      <h5><a href="tel:+19876543210" title=''>+1 9876543210</a></h5>
                  </Card>
                  </Col>
                  <Col md={4}>
                      <Card>
                          <img src={EmailUs} alt=""></img>
                          <p>Email Us</p>
                          <h5><a href="mailto:inquiry@realestate.com" title=''>inquiry@realestate.com</a></h5>
                      </Card>
                  </Col>
                  <Col md={4}>
                      <Card>
                          <img src={ConnectUs} alt=""></img>
                          <p>Connect with us</p>
                          <ul>
                            <li>
                              <a href="#" target="_blank">
                                <img src={Facebook} alt="Facebook" />
                              </a>
                            </li> 
                            <li>
                              <a href="#" target="_blank">
                                <img src={X} alt="X" />
                                </a>
                            </li>
                            <li>
                              <a href="#" target="_blank">
                                <img src={Instagram} alt="Instagram" />
                              </a>
                            </li>
                            <li>
                              <a href="#" target="_blank">
                                <img src={YouTube} alt="YouTube" />
                              </a>
                            </li>
                            <li>
                              <a href="#" target="_blank">
                                <img src={LinkedIn} alt="LinkedIn" />
                              </a>
                            </li>
                          </ul>
                      </Card>
                  </Col>
              </Row>
          </Container>
      </div>
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default ContactUs


